"use strict";var _interopRequireDefault=require("@babel/runtime/helpers/interopRequireDefault");var _styledComponents=_interopRequireDefault(require("styled-components"));Object.defineProperty(exports,"__esModule",{value:!0}),exports.Tender=exports.PaymentMethodsContainer=exports.CardContainer=exports.Card=exports.ButtonContainer=void 0;const ButtonContainer=exports.ButtonContainer=_styledComponents.default.div`
  display: grid;
  margin-top: 21px;
  justify-content: center;
  font-weight: 600;
`,CardContainer=exports.CardContainer=_styledComponents.default.div`
  &.mobile{
    width: 336px;
  }`,PaymentMethodsContainer=exports.PaymentMethodsContainer=_styledComponents.default.div`
.secure{
    display:flex;
    justify-content:center;
    font-style: normal;
    font-weight: 300;
    font-size: 12px;
    line-height: 16px;
    color: #2A2928;
    padding-top: 16px;
}
.consentText:hover{
  cursor:pointer
}
.consentText{
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 18px;
  align-items: center;
  text-align: center;
  font-feature-settings: 'liga' off, 'calt' off;
  color: #7B1A27;
  justify-content:center;
  margin-top: 8px
};

.ScheduleConsent{
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 21px;
  align-items: center;
  text-align: center;
  color: #2A2928;
  justify-content:center;
  margin-top: 8px
};`,Tender=exports.Tender=_styledComponents.default.div`
  display: flex;
  flex-direction:column;
  margin-top:16px;
  &.inactive{
    background: #F1F0EE;
  }
`,Card=exports.Card=_styledComponents.default.div`
  &.addPaymentOption{
    font-weight: bold;
  }
  .cardImage {
    border: none;
    border-radius: 8px;
    width: 318px;
    height: 188px;
    padding: 16px 0px 13px 16px;
    display: flex;
    flex-direction: column;
    background: #fff;
    border: 1px solid #DDD9D5;
  }

  .buttonSelected {
    border: none;
    height: 56px;
    justify-content:space-between;
    padding: 0px 16px 0px 16px;
    display: flex;
    background: ${a=>"true"===a?.children?.props?.carderror&&"FreshPass"===a?.children?.props.client?"#F1F0EE":"#fff"};
    align-items: center;
    border: 1.6px solid #2A2928;
    border-radius: 8px;
  }
  
  .cardImageMobile{
    border: none;
    border-radius: 8px;
    height: 56px;
    justify-content:space-between;
    padding: 0px 16px 0px 16px;
    display: flex;
    background: ${a=>"true"===a?.children?.props?.carderror&&"FreshPass"===a?.children?.props.client?"#F1F0EE":"#fff"};
    border: 1px solid #ddd9d5;
    align-items: center;
  }
  .cardContentContainer {
    width: 100%;
    padding: 0px 11px 16px 19px;
  }
  
  .arrow {
    border: 1px solid #c63939;
    border-width: 0 2px 2px 0;
    display: inline-block;
    padding: 3px;
    margin-bottom: 1px;
  }

  .button-arrow {
    border: 1px solid #7B1A27;
    border-width: 0 2px 2px 0;
    display: inline-block;
    padding: 3px;
    margin-bottom: 1px;
    margin-left: 4px;
  }
  
  .right {
    transform: rotate(-45deg);
    -webkit-transform: rotate(-45deg);
  }

  .cardNumber {
    text-transform: uppercase;
    margin-left: 8px;
    font-weight: 600;
    font-size: 14px;
    line-height: 20px;
    display:flex;
    margin-right:auto;
  }
  .expiryDetails {
    margin-top: 8px;
  }

  .expired {
    margin-top: 8px;
    color: #c63939;
  }

  .confirmBtn {
    color: #c63939;
    font-style: normal;
    font-weight: 600;
    font-size: 16px;
    margin-right:8px;
  }

  .visaImage {
    margin-right: auto;
  }

  .visaLogo {
    width: 40px;
    height: 24px;
    mix-blend-mode: darken;
  }

  .holderName {
    font-size: 12px;
    font-weight: 300;
    line-height: 16px;
    font-style: normal;
  }

  .maskedNumber {
    font-weight: 300;
    font-size: 18px;
    line-height: 25px;
  }

  .expiryDate {
    margin-left: 3px;
  }

  .details {
    background-color: white;
    display: flex;
  }
  .top {
    justify-content: space-between;
    align-items: center;
    display: flex;
    padding-right: 8px;
  }
  .bottom {
    display: flex;
    flex-direction: column;
    justify-content: end;
    flex-grow: 1;
    font-weight: 400;
    font-size: 14px;
    line-height: 21px;
    text-transform: capitalize;
  }

  .fpIneligible{
    color: #c63939;
    font-style: normal;
    font-weight: 600;
    font-size: 16px;
    margin-right:25px;
  }
  
`;